import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import ErrorIcon from 'material-ui/svg-icons/alert/error-outline';
import { white } from 'material-ui/styles/colors'
import { register } from '../../redux/actions';
import { Link } from 'react-router-dom';
import ErrorBox from '../common/ErrorBox';
import CenteredCard from '../CenteredCard';

const paperStyle = {
    width: 'auto',
    height: 'auto',
    margin: '10px',
    padding: '30px',
    paddingTop: '15px'
}

const paperErrorStyle = {
    margin: '0px',
    padding: '10px',
    verticalAlign: 'middle',
    color: 'white',
    backgroundColor: 'salmon'
}

const errorIconStyle = {
    verticalAlign: 'middle',
    paddingBottom: '3px'
}

const requiredText = "This field is required";
const RequiredTextField = ({label, error, handleChange}) => <TextField 
    floatingLabelText={ label }
    errorText = { error ? "This field is required" : ''}
    onChange = { (e, value) => handleChange(value) }
/>;

const Register = ({status, error, errorText, newUser, formUpdate, onRegister, inputErrors}) => {
    if (status === 201) {
        return <Grid fluid>
            <Row>
                <Col xs={12}>
                    <Row center="xs">
                        <Paper>
                            <Col xs={12}>
                                <h1>Thank You For Registering</h1>
                                <p>
                                    An email has been sent to the email address you provided. 
                                    Please check your inbox and verify your email address to activate your account.
                                </p>
                            </Col>
                        </Paper>
                    </Row>
                </Col>
            </Row>
        </Grid>;
    } else {
        return <Grid fluid>
            <Row>
                <Col xs= { 12 }>
                    <Row center="xs">
                        <Paper style={paperStyle} zDepth={3}>
                            <Col xs={ 12 }>
                                <h1>Register</h1>
                                <ErrorBox open={error} text={errorText}/>
                                <form>
                                    <RequiredTextField 
                                        label="Email" 
                                        error={inputErrors.email}
                                        handleChange={value => formUpdate({email: value})}
                                    />
                                    <br />
                                    <RequiredTextField 
                                        label="Password" 
                                        error={inputErrors.password}
                                        handleChange={value => formUpdate({password: value})}
                                    />
                                    <br />
                                    <RequiredTextField 
                                        label="First Name" 
                                        error={inputErrors.firstName}
                                        handleChange={value => formUpdate({firstName: value})}
                                    />
                                    <br/>
                                    <RequiredTextField 
                                        label="Last Name" 
                                        error={inputErrors.lastName}
                                        handleChange={value => formUpdate({lastName: value})}
                                    />
                                    <br/>
                                    <RequiredTextField 
                                        label="Phone" 
                                        error={inputErrors.phone}
                                        handleChange={value => formUpdate({phone: value})}
                                    />
                                    <br />
                                    <RequiredTextField 
                                        label="Address" 
                                        error={inputErrors.street1}
                                        handleChange={value => formUpdate({street1: value})}
                                    />
                                    <br/>
                                    <TextField 
                                        floatingLabelText="Address 2" 
                                        onChange={(e, value)  => formUpdate({street2: value})}
                                    />
                                    <br />
                                    <RequiredTextField 
                                        label="Zip Code" 
                                        error={inputErrors.zip}
                                        handleChange={value => formUpdate({zip: value})}
                                    />
                                    <br />
                                    <RaisedButton primary={true}
                                        type='submit'
                                        label='Submit' 
                                        onClick={e => {
                                            e.preventDefault();
                                            onRegister(newUser);
                                        }}
                                    />
                                </form>
                            </Col>
                        </Paper>
                    </Row>
                </Col>
            </Row>
        </Grid>;
    };
};

function mapDispatchToProps(dispatch) {
    return { 
        formUpdate: newValue => dispatch({type: "REG_FORM_UPDATE", newValue}),
        onRegister: newUser => dispatch(register(newUser)) 
    };
}

function mapStateToProps(state) {
    return { 
        status: state.registration.status, 
        error: state.registration.error, 
        errorText: state.registration.errorText,
        newUser: state.registration.newUser,
        inputErrors: state.registration.inputErrors 
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Register);



// WEBPACK FOOTER //
// ./src/components/auth/Register.js